"use strict";import{tag as r}from"../custom-tag.js";export function expandFilledIcon({height:l=16,width:e=16,hidden:a=!1,title:t="Expand filled"}={}){return r`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${e}
      height=${l}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${a?"true":"false"}"
      role="img"
      aria-label="${t}"
    >
      <mask
        id="expand-filled_svg__mask0_6875_6282"
        width="20"
        height="20"
        x="2"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m-1.038 15.825h-4.21a.527.527 0 0 1-.527-.526v-4.21h1.053v2.94l2.631-2.632.744.744-2.63 2.632h2.939zm6.842-10.833v3.993H16.75v-2.94l-3.159 3.158-.744-.744 3.16-3.16h-2.942V6.246h3.995l.008-.008.008.008h.2a.526.526 0 0 1 .527.527v.2l.01.01z"
        />
      </mask>
      <g mask="url(#expand-filled_svg__mask0_6875_6282)">
        <path fill="currentColor" d="M24-.007H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=expandFilled.js.map
